import { atom } from '@pixum/store';
import type { UploadErrorState } from '@pixum/types';

export const uploadErrorStateService = atom<UploadErrorState>({ uploadErrors: [] });
